import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ProductCardProps {
  title: string;
  description: string;
  href: string;
  external?: boolean;
  badge?: string;
}
export function ProductCard({
  title,
  description,
  href,
  external = false,
  badge
}: ProductCardProps) {
  return <a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className="group block bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden" data-id="element-354">
      <div className="p-6" data-id="element-355">
        {/* Placeholder logo area */}
        <div className="w-full h-24 bg-gray-200 rounded-md mb-4 flex items-center justify-center" data-id="element-356">
          <span className="text-gray-500 text-sm font-medium" data-id="element-357">Logo</span>
        </div>

        {badge && <span className="inline-block px-3 py-1 text-xs font-semibold text-orange bg-orange/10 rounded-full mb-3" data-id="element-358">
            {badge}
          </span>}

        <h3 className="text-lg font-semibold text-navy mb-2 group-hover:text-orange transition-colors" data-id="element-359">
          {title}
        </h3>

        <p className="text-gray-600 text-sm mb-4 line-clamp-2" data-id="element-360">{description}</p>

        <div className="flex items-center text-orange font-medium text-sm group-hover:gap-2 transition-all" data-id="element-361">
          <span data-id="element-362">Learn More</span>
          <ArrowRightIcon className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-363" />
        </div>
      </div>
    </a>;
}